var ShareOptionValues;
(function (ShareOptionValues) {
    ShareOptionValues["EVERYONE"] = "everyone";
    ShareOptionValues["PRIVATE"] = "private";
    ShareOptionValues["TEAMS"] = "teams";
})(ShareOptionValues || (ShareOptionValues = {}));
export default ShareOptionValues;
